
import pimg4 from '../images/project/4.webp'




const Projects = [
    
 
    {
        id: '1',
       title: 'Bold Ideas and Strong Team.',
        subtitle: 'Join Our Journey of Innovation',
        slug: '1',
        pimg1: pimg4,
      
    },
  




]
export default Projects;